module.exports = __webpack_public_path__ + "static/media/title.e8fe641e.png";